import PropTypes from 'prop-types';
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider, connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import GenericError from '../components/Error';
import { ModalContainer } from '../containers/ModalContainer';
import Routes from './routes';

const Root = ({ store, error }) => {
  // Wrap app in SnackbarProvider for notistack
  const { SnackbarProvider } = require('notistack');
  return (
    <DndProvider backend={HTML5Backend} manager={undefined}>
      <Provider store={store}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          classes={{ containerRoot: 'customSnackbarContainer' }}
        >
          <BrowserRouter>
            <ModalContainer />
            {error?.get('show') && <GenericError />}
            {!error.get('show') && <Routes />}
          </BrowserRouter>
        </SnackbarProvider>
      </Provider>
    </DndProvider>
  );
};

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default connect((state) => ({
  error: state.error,
}))(Root);
